/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       DeleteImage.tsx
 * @author     Christian Ascone
 * @date       9/20/19 5:15 PM
 */

import React from 'react';
import {Image} from "react-native";

export function DeleteImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/delete.png')
            }
        />
    );
}